import * as z from "zod";

export const CompanySchema = z.object({
  Id: z.number(),
  CompanyNameAr: z.string(),
  CompanyNameEn: z.string(),
  ActivityAr: z.string(),
  ActivityEn: z.string(),
  OilNumber: z.number().optional(),
  Visible: z.boolean(),
  Value: z.string().optional(),
});

export const CompaniesListSchema = z.array(CompanySchema);

export const CompaniesListResponseSchema = z.object({
  Companies: CompaniesListSchema,
});

export type Company = z.infer<typeof CompanySchema>;
export type CompaniesList = z.infer<typeof CompaniesListSchema>;
